import { Box, ButtonBase, Typography } from '@mui/material';

interface ProfileUserCardProps {
  name: string;
  email: string;
  image: string;
  onClick: () => void;
}

const ProfileUserCard = (props: ProfileUserCardProps) => {
  return (
    <ButtonBase
      sx={{
        textAlign: 'initial',
        minHeight: '80px',
        width: 300,
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
        borderRadius: '20px',
        border: '1px solid #A8A8A8',
      }}
      onClick={props.onClick}
      id={'invitation-email'}
    >
      <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'start', p: 2 }}>
        <img style={{ width: 35, paddingRight: 5 }} src={props.image} alt="Invitation Email" />
        <Box
          sx={{
            width: 250,
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Work Sans',
              fontStyle: 'normal',
              fontSize: '15px',
              lineHeight: '23px',
              color: '#14142B',
              wordBreak: 'break-word',
              whiteSpace: 'normal',
              textAlign: 'center',
              width: '100%',
            }}
          >
            {props.name}
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Work Sans',
              fontStyle: 'normal',
              fontWeight: 500,
              fontSize: '15px',
              lineHeight: '14px',
              color: '#14142B',
              wordBreak: 'break-word',
              whiteSpace: 'normal',
              textAlign: 'center',
              width: '100%',
            }}
          >
            {props.email}
          </Typography>
        </Box>
      </Box>
    </ButtonBase>
  );
};

export default ProfileUserCard;
